  <mat-card>
      <mat-card-header>
          <mat-card-title>Dettaglio azienda</mat-card-title>
      </mat-card-header>
      <mat-card-content class="content">

        <form [formGroup]="registerForm" (ngSubmit)="save()">

          <mat-form-field [style.display]="getConfigurazione().Nome" class="example-full-width">
            <mat-label class="text-sm">Nome</mat-label>
            <input matInput placeholder="Nome" formControlName="Nome" name="Nome" required>
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Partitaiva" class="example-full-width">
            <mat-label class="text-sm">Partita IVA</mat-label>
            <input matInput placeholder="Partitaiva" formControlName="Partitaiva" name="Partitaiva">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Codicefiscale" class="example-full-width">
            <mat-label class="text-sm">Codice fiscale</mat-label>
            <input matInput placeholder="Codicefiscale" formControlName="Codicefiscale" name="Codicefiscale">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Email" class="example-full-width">
            <mat-label class="text-sm">email</mat-label>
            <input matInput placeholder="Email" formControlName="Email" name="Email">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Pec" class="example-full-width">
            <mat-label class="text-sm">PEC</mat-label>
            <input matInput placeholder="Pec" formControlName="Pec" name="Pec">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Telefono" class="example-full-width">
            <mat-label class="text-sm">Telefono</mat-label>
            <input matInput placeholder="Telefono" formControlName="Telefono" name="Telefono">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Cellulare" class="example-full-width">
            <mat-label class="text-sm">Cellulare</mat-label>
            <input matInput placeholder="Cellulare" formControlName="Cellulare" name="Cellulare">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Svi" class="example-full-width">
            <mat-label class="text-sm">SDI</mat-label>
            <input matInput placeholder="Svi" formControlName="Svi" name="Svi">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Missione" class="example-full-width">
            <mat-label class="text-sm">Missione</mat-label>
            <input matInput placeholder="Missione" formControlName="Missione" name="Missione">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Ragionesociale" class="example-full-width">
            <mat-label class="text-sm">Ragione sociale</mat-label>
            <input matInput placeholder="Ragione sociale" formControlName="Ragionesociale" name="Ragionesociale">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Attivita" class="example-full-width">
            <mat-label class="text-sm">Attivita</mat-label>
            <input matInput placeholder="Attivita" formControlName="Attivita" name="Attivita">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Numerodipendenti" class="example-full-width">
            <mat-label class="text-sm">Numero dipendenti</mat-label>
            <input matInput placeholder="Numero dipendenti" formControlName="Numerodipendenti" name="Numerodipendenti">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Rea" class="example-full-width">
            <mat-label class="text-sm">Rea</mat-label>
            <input matInput placeholder="Rea" formControlName="Rea" name="Rea">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Datarea" appearance="fill">
            <mat-label class="text-sm">Data Rea</mat-label>
             <input matInput
              [matDatepicker]="picker" placeholder="Datarea" name="Datarea" formControlName="Datarea"/>
             <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
             <mat-datepicker #picker></mat-datepicker>
         </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Cameracommercio" class="example-full-width">
            <mat-label class="text-sm">Camera commercio</mat-label>
            <input matInput placeholder="Cameracommercio" formControlName="Cameracommercio" name="Cameracommercio">
          </mat-form-field>

          <mat-form-field [style.display]="getConfigurazione().Codice" class="example-full-width" [hidden]=true>
            <mat-label class="text-sm">Codice</mat-label>
            <input matInput placeholder="Codice" formControlName="Codice" name="Codice">
          </mat-form-field>



        </form>
      </mat-card-content>
      <mat-card-actions>
        <table>
          <tr>
            <td>
              <button mat-raised-button  color="primary" (click)="save()">Salva</button>
            </td>
            <td>
              <button mat-raised-button  color="primary" (click)="cancel()">Indietro</button>
            </td>
          </tr>
        </table>
      </mat-card-actions>

  </mat-card>
